import wpdmIcons from "../../libs/icons";
import Columns from "../../libs/columns";
import Select from 'react-select'
import AsyncSelect from 'react-select/async';
import makeAnimated from 'react-select/animated';
import Util from "../../libs/util";

const {InspectorControls, PanelColorSettings} = wp.editor;
const {TextControl, TextareaControl, SelectControl, ServerSideRender, Modal, Button, PanelBody} = wp.components;
const {registerBlockType} = wp.blocks;
const {withState} = wp.compose;
const { __ } = wp.i18n;
const animatedComponents = makeAnimated();

registerBlockType('download-manager/category-blocks', {
    title: 'Category Cards',

    description: 'Download Manager Category Cards',

    keywords: [
        __( 'download manager digital ecommerce store product sell' ),
        __( 'file manager' ),
        __( 'product category categories' )
    ],

    icon: wpdmIcons.theCat(),

    category: 'wpdm-blocks',

    attributes: {
        cats: {
            type: 'string',
            default: ""
        },
        cols: {
            type: 'string',
            default: "3"
        },
        button_color: {
            type: 'string',
            default: "rgb(0, 115, 255)"
        },
        hover_color: {
            type: 'string',
            default: "rgb(0, 115, 255)"
        },
        template: {
            type: 'string',
            default: ''
        },
        className: {
            type: 'string',
            default: ''
        }
    },

     edit({attributes, className, setAttributes}) {


        function onChangeTemplate(newTemplate) {
            setAttributes({ template: newTemplate });
        }

         function onSelectCategory(categories) {
             console.log(categories);
             var selected_cats = [];
             jQuery.each(categories, function (index, category) {
                 selected_cats.push(category.value);
             });
             console.log(selected_cats.join(','));
             setAttributes({cats: selected_cats.join(',')});

         }

         function selectedCats(cats) {
             var selected_cats = [];
             cats = cats.split(',');
             jQuery.each(wpdm_categories, function (index, category) {
                 if (cats.indexOf(category.value) !== -1) {
                     selected_cats.push(category);
                 }
             });
             return selected_cats;
         }

         /* Default colors */
         const defaultColors = Util.defaultColor();
        console.log(attributes);
        return ([
            <InspectorControls>
                <div className="w3eden">
                    <PanelBody>
                        <div className="form-group">
                            <label>Include Categories:</label>
                            <Select
                                id={"categories"}
                                name={"categories"}
                                closeMenuOnSelect={false}
                                components={animatedComponents}
                                defaultValue={selectedCats(attributes.cats)}
                                isMulti
                                options={wpdm_categories}
                                onChange={(categories) => onSelectCategory(categories)}
                            />
                        </div>
                        <div className="form-group">
                            <div className="form-group">
                                <SelectControl
                                    label={"Columns:"}
                                    value={attributes.cols}
                                    class={"form-control wpdm-custom-select"}
                                    options={[{label: "4 columns", value:4}, {label: "3 columns", value:3},{label: "2 columns", value:2},{label:'1 column', value:1}]}
                                    onChange={ ( cols ) => setAttributes( { cols: cols } ) }
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <div className="form-group">
                                <SelectControl
                                    label={"Template:"}
                                    value={attributes.template}
                                    class={"form-control wpdm-custom-select"}
                                    options={[{label: "Default", value:'default'}]}
                                    onChange={ ( template ) => setAttributes( { template: template } ) }
                                />
                            </div>
                        </div>
                        <PanelColorSettings
                            title={ __( 'Button Color' ) }
                            initialOpen={ false }
                            colorSettings={ [ {
                                value: attributes.button_color,
                                onChange: button_color => setAttributes( { button_color: button_color } ),
                                label: __( 'Border Color' ),
                                colors: defaultColors,
                            } ] }
                        >
                        </PanelColorSettings>
                        <PanelColorSettings
                            title={ __( 'Hover Color' ) }
                            initialOpen={ false }
                            colorSettings={ [ {
                                value: attributes.hover_color,
                                onChange: hover_color => setAttributes( { hover_color: hover_color } ),
                                label: __( 'Hover Color' ),
                                colors: defaultColors,
                            } ] }
                        >
                        </PanelColorSettings>


                    </PanelBody>
                </div>
            </InspectorControls>,
            <ServerSideRender
                block = {"download-manager/category-blocks"}
                attributes = {attributes}
            />
        ]);

    },
    save() {
        return null;
    }
});
